import { useFormik } from "formik";
import { callGetGSTINDetails } from "http/gstin/gstin";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Loader from "react-spinner-loader";
import { useAsyncDebounce } from "react-table";
import * as Yup from "yup";
import { callGetCity, callGetState, deleteAddress } from "../../http/fundLync/entityAndAddress.helper";
import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import { decryptedValue, isPermission, uId } from "common/utility";
import ToastDialog from "components/Common/ToastDialog";
import {
  addAddress,
  editAddress,
  getAddress,
  getAuthorisedPersonList,
} from "http/fundLync/entityAndAddress.helper";
import CommonDialog from "components/Common/CommonDialog";

const EntityAddress = ({isOpen,onAccordionToggle }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isAddAddressOpen, setAddAddressOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [stateList, setState] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [addressList, setaddressList] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const [entity, setAddress] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isNewAddressPermission, setNewAddressPermission] = useState(false);
  const [isEditAddressPermission, setEditAddressPermission] = useState(false);
  const [selectedIsAuthPerson, setSelectedIsAuthPerson] = useState("");
  const [errorAuthPerson, setErrorAuthPerson] = useState("");
  const [authorisedPersonList, setAuthorisedPersonList] = useState([]);
  const [selectedViewAddress, setSelectedViewAddress] = useState(null);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });

  const [isViewOpen, setViewOpen] = useState(false);
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  
  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])
  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      address1: (entity && entity[0].address1) || "",
      address2: (entity && entity[0].address2) || "",
      address3: (entity && entity[0].address3) || "",
      city: (entity && entity[0].city.toUpperCase()) || "",
      state: (entity && entity[0].state.toUpperCase()) || "",
      pincode: (entity && entity[0].pincode) || "",
      addressType: (entity && entity[0].addressType) || "",
      id: (entity && entity[0].id) || "",
      personId: (entity && entity[0].personId) || "",
      isAuthPerson: (entity && entity[0].isAuthPerson !== null?  entity[0].isAuthPerson : '')
    },
    validationSchema: Yup.object({
      address1: Yup.string().required("Please Enter Address line 1"),
      address2: Yup.string(),
      address3: Yup.string(),
      city: Yup.string().required("Please Enter City"),
      isAuthPerson: Yup.boolean().required("Please Select address type"),
      state: Yup.string().required("Please Enter State"),
      personId: selectedIsAuthPerson == 'Yes'
        ? Yup.number().required("Please Select Authorised Person")
        : Yup.number(),
      pincode: Yup.number()
        .required("Please Enter Pincode")
        .typeError("Pincode Must be a Number")
        .positive("Pincode must be a positive number")
        .integer("Pincode must be an integer")
        .test('len', 'Pincode must be exactly 6 digits', val => val && val.toString().length === 6),
      addressType: Yup.string().required("Address Type is Required"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const entity = {
          id: values.id,
          address1: values.address1,
          address2: values.address2,
          address3: values.address3,
          city: values.city,
          state: values.state,
          pincode: values.pincode,
          addressType: values.addressType,
          entityId: addressList[0]?.entityId,
        };
        entity.isAuthPerson = values.isAuthPerson
        if (values.personId) {
          entity.personId = values.personId
        }
        editAddress(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Address Saved",
                showToast: true,
                role: "success",
              })
              callAddressAfterSave();
              setAddAddressOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        const entity = {
          address1: values.address1,
          address2: values.address2 || "",
          address3: values.address3 || "",
          city: values.city,
          state: values.state,
          pincode: values.pincode,
          addressType: values.addressType,
          entityId: addressList[0]?.entityId || entityId,
        };
        entity.isAuthPerson = values.isAuthPerson
        if (values.personId) {
          entity.personId = values.personId
        }
        addAddress(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Address Saved",
                showToast: true,
                role: "success",
              });
              callAddressAfterSave();
              setAddAddressOpen(false);
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }

      validation.resetForm();
    },
  });

  useEffect(() => {
    if(isOpen){
    getAddress({ entityId })
      .then((response) => {
        if(response?.data?.data){
          setaddressList(response.data.data);
        }else{
          setaddressList([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
    callGetState()
      .then((response) => {
        if (response.code == "200") {
          setState(response.data);
        }
      })
      .catch((error) => { });

     } checkPermissions();

  }, [isOpen,entityId]);

  const checkPermissions = async () => {
    const isAddpermission = await isPermission("address", "create_permission");
    const editAddressPermission = await isPermission("address", "edit_permission");
    setNewAddressPermission(isAddpermission);
    setEditAddressPermission(editAddressPermission);
  };

  const handleCustomerClicks = () => {
    setAddAddressOpen(true);
    setIsEdit(false);
    setAddress(null);
  };

  const handleCancelrClicks = () => {
    validation.resetForm();
    setAddAddressOpen(false);
    setAddress(null);
  };

  const EditAddress = (id) => {
    setIsEdit(true);
    const filteredData = addressList.filter((elem) => {
      return elem.id == id;
    });
    if (filteredData.length > 0) {
      getCityList(filteredData[0]?.state)
    }
    setAddress(filteredData);
    if (filteredData[0].isAuthPerson) {
      AuthorisedPersonList()
      setSelectedIsAuthPerson('Yes')

    } else if (filteredData[0].isAuthPerson != null) {
      setSelectedIsAuthPerson('No')
    }
    setAddAddressOpen(true);
  };

  const ViewAddress = (id) => {
    const selectedAddress = addressList.find((elem) => elem.id == id);
    setSelectedViewAddress(selectedAddress);
    setViewOpen(true);
  };

  function setStateValue(data, state) {
    if (state) {
      for (const item of data) {
        if (item.name === state) {
          const value = { label: `${item.name}`, value: state };
          return value;
        }
      }
    }
  }

  function setAuthPerson(data, person) {
    if (person) {
      for (const item of data) {
        if (item.id === person) {
          const value = { label: `${item.firstName + ' ' + item.lastName}`, value: person };
          return value;
        }
      }
    }
  }

  function setCityValue(data, city) {
    if (city) {
      for (const item of data) {
        if (item.cityName === city) {
          const value = { label: `${item.cityName}`, value: city };
          return value;
        }
      }
    } else {
      return null
    }
  }

  const handleInputChange = (value) => {
    validation.setFieldValue("state", value);
    validation.setFieldValue("city", "")
    getCityList(value)
  };

  const handleAuthPersonChange = (value) => {
    validation.setFieldValue("personId", value);
  };

  const handleCityChange = (value) => {
    validation.setFieldValue("city", value);
  };

  const getCityList = (value) => {
    callGetCity({ state: value })
      .then((response) => {
        if (response.status) {
          setCityList(response?.data)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
    setAddAddressOpen(false);
    setIsEdit(false);
    if (onAccordionToggle) {
      onAccordionToggle(!isDropdownOpen);
    }
  };

  const callAddressAfterSave = () => {
    getAddress({ entityId })
      .then((response) => {
        if(response?.data?.data){
          setaddressList(response.data.data);
        }else{
          setaddressList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onGSTINChange = useAsyncDebounce((value) => {
    setLoader(true);
    findGSTINDetails(value);
  }, 400);

  const findGSTINDetails = (gstin) => {
    callGetGSTINDetails({ gstnIn: gstin })
      .then((result) => {
        if (result.code == 200 && result.status) {
          const { data: gstinDetails } = result;
          const { tradeNam, ctb } = gstinDetails;
          const { stcd, dst, pncd, bnm, flno, landMark } =
            gstinDetails.pradr.addr;
          validation.setFieldValue("entityName", tradeNam);
          validation.setFieldValue("entityConstitution", ctb);
          validation.setFieldValue("address1", bnm);
          validation.setFieldValue("address2", flno);
          validation.setFieldValue("address3", landMark);
          validation.setFieldValue("pincode", pncd);
          validation.setFieldValue("city", dst);
          if (stateList && stcd) {
            validation.setFieldValue("state", stcd);
          }
          validation.setFieldValue("pan", gstin.substring(2, 12));
          setLoader(false);
        } else {
          setLoader(false);
          setToastInfo({
            message: "Incorrect GSTIN",
            showToast: true,
            role: "error",
          });
          validation.setFieldValue("entityName", "");
          validation.setFieldValue("entityConstitution", "");
        }
      })
      .catch((e) => {
        setToastInfo({
          message: "GSTIN not found",
          showToast: true,
          role: "error",
        });
        validation.setFieldValue("companyName", "");
        validation.setFieldValue("constitution", "");
      })
      .finally((f) => { });
  };

  const handleIsAuthPerson = (event) => {
    if (event.target.value == "Yes") {
      AuthorisedPersonList()
      validation.setFieldValue("isAuthPerson", true);
    } else {
      validation.setFieldValue("isAuthPerson", false);
    }
    setSelectedIsAuthPerson(event.target.value);
    setErrorAuthPerson("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedIsAuthPerson == "") {
      setErrorAuthPerson("Please select an option");
    }
  };

  const AuthorisedPersonList = () => {
    getAuthorisedPersonList({ entityId })
      .then((response) => {
        const allProprietors = response?.data?.data || [];
        if (allProprietors.length > 0) {
          setAuthorisedPersonList(allProprietors);
        } else {
          setAuthorisedPersonList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }
  const deleteDetail = (id) => {
    const message = 'Are you sure you want to delete this data?'
    const data = {id}
    setShowCommonDialog({ isShow: true, message, data })
  };

  const dialogActionAccept = (action, data) => {
    if (action == 1) {
        setShowCommonDialog({ isShow: false })
        deleteAddress({id : data.id})
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "Address Deleted Succesfully",
              showToast: true,
              role: "success",
            });
            callAddressAfterSave();
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
        setShowCommonDialog({ isShow: false })
    }
  }

  return (
    <React.Fragment>
      <Row lg="12">
        <div>
          <Card style={{ padding: "10px" }}>
            <div
              className="d-flex justify-content-between mt-1"
              style={{ cursor: "pointer" }}
              onClick={toggleDropdown}
            >
              <div>
                <h5>Address</h5>
              </div>
              <div className="me-2">
                <i
                  className={`fas fa-angle-${isDropdownOpen ? "up" : "down"}`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {isViewOpen && selectedViewAddress && (
              <div>
                <div className="text-sm-end">
                    <Button
                      type="button"
                      color="outline-success"
                      className="btn-rounded mb-2 me-2"
                      onClick={() => setViewOpen(false)}
                    >
                      close
                    </Button>
                </div>
              <Row className="mb-3">
                <Col sm="6" md="4" lg="12" className="mb-3 mt-2">
                  <Label className="d-block entityDetails">Address</Label>
                  <span className="mb-0 entityDetailsValue">{`${selectedViewAddress.address1 || ''} ${selectedViewAddress.address2 || ''} ${selectedViewAddress.address3 || ''}`}</span>
                </Col>
                <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                  <Label className="d-block entityDetails">Address Type</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewAddress.addressType === "head_office_address" ? "Head Office Address" : "Registered Business Address"}</span>
                </Col>
                <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                  <Label className="d-block entityDetails">City Name</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewAddress.city}</span>
                </Col>
                <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                  <Label className="d-block entityDetails">State name</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewAddress.state}</span>
                </Col>
                <Col sm="6" md="4" lg="3" className="mb-2 mt-2">
                  <Label className="d-block entityDetails">Pincode</Label>
                  <span className="mb-0 entityDetailsValue">{selectedViewAddress.pincode}</span>
                </Col>
              </Row>
              </div>
            )}
            {isAddAddressOpen && (
              <div>
                <div>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      handleSubmit(e)
                      return false;
                    }}
                  >
                    <Row className="mb-3">
                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Is this address of authorised person?
                        </Label>
                        <div className="d-flex ms-4">
                          <div>
                            <Input
                              type="radio"
                              id="isAuthPerson1"
                              name="isAuthPerson"
                              value="Yes"
                              onChange={() => { }}
                              style={{ border: "1px solid black" }}
                              checked={selectedIsAuthPerson == "Yes"}
                              onClick={handleIsAuthPerson}
                            />
                            <Label
                              htmlFor="isAuthPerson1"
                              className="ms-2"
                            >
                              Yes
                            </Label>
                          </div>
                          <div className="ms-4">
                            <Input
                              type="radio"
                              name="isAuthPerson"
                              id="isAuthPerson2"
                              onChange={() => { }}
                              value="No"
                              style={{ border: "1px solid black" }}
                              checked={selectedIsAuthPerson == "No"}
                              onClick={handleIsAuthPerson}
                            />
                            <Label
                              htmlFor="isAuthPerson2"
                              className="ms-2"
                            >
                              No
                            </Label>
                          </div>
                        </div>
                        {errorAuthPerson && (
                          <p
                            style={{
                              color: "rgb(245,116,116)",
                              fontSize: "11px",
                            }}
                            className="ms-4"
                          >
                            {errorAuthPerson}
                          </p>
                        )}
                      </Col>

                      {selectedIsAuthPerson == 'No' && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">GSTIN</Label>
                          <Input
                            name="gstnIn"
                            type="text"
                            placeholder="Enter GSTIN"
                            onChange={(e) => {
                              validation.handleChange(e);
                              onGSTINChange(e.target.value);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.gstnIn || ""}
                            invalid={
                              validation.touched.gstnIn &&
                                validation.errors.gstnIn
                                ? true
                                : false
                            }
                          />
                          {validation.touched.gstnIn &&
                            validation.errors.gstnIn ? (
                            <FormFeedback type="invalid">
                              {validation.errors.gstnIn}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      )}

                      {selectedIsAuthPerson == 'Yes' && (
                        <Col sm="12" md="6">
                          <Label className="form-label mt-4">Select Authorised Person</Label>
                          <Select
                            options={authorisedPersonList.map((option, index) => ({
                              label: option.firstName + ' ' + option.lastName,
                              value: option.id,
                            }))}
                            className={`${validation.touched.personId && validation.errors.personId
                              ? "is-invalid"
                              : ""
                              }`}
                            name="personId"
                            id="personId"
                            onChange={(selectedOption) => {
                              handleAuthPersonChange(selectedOption.value);
                            }}
                            value={setAuthPerson(
                              authorisedPersonList,
                              validation.values.personId
                            )}
                          />
                          {validation.touched.personId &&
                            validation.errors.personId && (
                              <FormFeedback>
                                {validation.errors.personId}
                              </FormFeedback>
                            )}
                        </Col>
                      )}

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Address Type *
                        </Label>
                        <Input
                          name="addressType"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.addressType || ""}
                          invalid={
                            validation.touched.addressType &&
                              validation.errors.addressType
                              ? true
                              : false
                          }
                        >
                          <option value="" disabled>
                            Select address type
                          </option>
                          <option value="registered_business_address">
                            Registered Business Address
                          </option>
                          <option value="head_office_address">
                            Head Office Address
                          </option>
                        </Input>
                        {validation.touched.addressType &&
                          validation.errors.addressType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.addressType}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">
                          Address Line1 *
                        </Label>
                        <Input
                          name="address1"
                          type="text"
                          placeholder="Enter Address Line1"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address1 || ""}
                          invalid={
                            validation.touched.address1 &&
                              validation.errors.address1
                              ? true
                              : false
                          }
                        />
                        {validation.touched.address1 &&
                          validation.errors.address1 ? (
                          <FormFeedback type="invalid">
                            {validation.errors.address1}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Address Line2</Label>
                        <Input
                          name="address2"
                          type="text"
                          placeholder="Enter Address Line2"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address2 || ""}
                          invalid={
                            validation.touched.address2 &&
                              validation.errors.address2
                              ? true
                              : false
                          }
                        />
                        {validation.touched.address2 &&
                          validation.errors.address2 ? (
                          <FormFeedback type="invalid">
                            {validation.errors.address2}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Address Line3</Label>
                        <Input
                          name="address3"
                          type="text"
                          placeholder="Enter Address Line3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address3 || ""}
                          invalid={
                            validation.touched.address3 &&
                              validation.errors.address3
                              ? true
                              : false
                          }
                        />
                        {validation.touched.address3 &&
                          validation.errors.address3 ? (
                          <FormFeedback type="invalid">
                            {validation.errors.address3}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">State*</Label>
                        <Select
                          options={stateList.map((option, index) => ({
                            label: option.name,
                            value: option.name,
                          }))}
                          className={`${validation.touched.state && validation.errors.state
                            ? "is-invalid"
                            : ""
                            }`}
                          name="state"
                          id="state"
                          onChange={(selectedOption) => {
                            handleInputChange(selectedOption.value);
                          }}
                          value={setStateValue(
                            stateList,
                            validation.values.state
                          )}
                        />
                        {validation.touched.state &&
                          validation.errors.state && (
                            <FormFeedback>
                              {validation.errors.state}
                            </FormFeedback>
                          )}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">City*</Label>
                        <Select
                          options={cityList.map((option) => ({
                            label: option.cityName,
                            value: option.cityName,
                          }))}
                          className={`select-dropdown ${validation.touched.city && validation.errors.city
                            ? "is-invalid"
                            : ""
                            }`}
                          name="city"
                          id="city"
                          onChange={(selectedOption) => {
                            handleCityChange(selectedOption.value);
                          }}
                          value={setCityValue(
                            cityList,
                            validation.values.city
                          )}
                        />
                        {validation.touched.city && validation.errors.city ? (
                          <FormFeedback type="invalid">
                            {validation.errors.city}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col sm="12" md="6">
                        <Label className="form-label mt-4">Pincode*</Label>
                        <Input
                          name="pincode"
                          type="text"
                          placeholder="Enter pincode"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.pincode || ""}
                          invalid={
                            validation.touched.pincode &&
                              validation.errors.pincode
                              ? true
                              : false
                          }
                        />
                        {validation.touched.pincode &&
                          validation.errors.pincode ? (
                          <FormFeedback type="invalid">
                            {validation.errors.pincode}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row  className="mb-3">
                      <Col>
                        <div className="text-end">
                          <button
                            type="button"
                            className="btn btn-outline-secondary save-customer me-2"
                            onClick={handleCancelrClicks}
                          >
                            Cancel
                          </button>
                          {isEdit ? (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Update
                          </button>
                          ): (
                            <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            )}
            {isDropdownOpen && (
              <Row>
                <div className="text-sm-end">
                  {isNewAddressPermission && (
                    <Button
                      type="button"
                      color="success"
                      className="btn-rounded mb-2 me-2"
                      onClick={handleCustomerClicks}
                    >
                      <i className="mdi mdi-plus me-1" />
                      New Address
                    </Button>
                  )}
                </div>
                <Col xs="12" className="mt-1 mb-2">
                  <div className="table-responsive">
                    <Table className="table table-bordered table-striped mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Id</th>
                          <th>Address</th>
                          <th>Address Type</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Pincode</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {addressList.length == 0 ? (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No data found
                            </td>
                          </tr>
                        ) : (
                          addressList.map((elem, index) => (
                            <tr key={uId()}>
                              <td>{index + 1}</td>
                              <td>{elem.address1}</td>
                              <td>
                                {elem.addressType == "head_office_address"
                                  ? "Head Office Address"
                                  : "Registered Business Address"}
                              </td>
                              <td>{elem.city}</td>
                              <td>{elem.state}</td>
                              <td>{elem.pincode}</td>
                              <td>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    className="card-drop"
                                  >
                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                  </DropdownToggle>

                                  {isEditAddressPermission && 
                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      onClick={() => {
                                        EditAddress(elem.id);
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-16 text-success me-1"
                                        id="edittooltip"
                                      ></i>
                                      Edit
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="edittooltip"
                                      >
                                        Edit
                                      </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        ViewAddress(elem.id);
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-eye font-size-16  text-success me-1"
                                        id="viewtooltip"
                                      ></i>
                                      View
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="viewtooltip"
                                      >
                                        View
                                      </UncontrolledTooltip>
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => {
                                            deleteDetail(elem.id);
                                        }}
                                        >
                                        <i
                                        className="mdi mdi-delete font-size-16 text-success me-1"
                                        id="deletetooltip"
                                        ></i>
                                        Delete
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="deletetooltip"
                                        >
                                        Delete
                                        </UncontrolledTooltip>
                                    </DropdownItem>
                                  </DropdownMenu>}
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            )}
          </Card>
        </div>
      </Row>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loader} type="box" message="Fetching Data" />
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionAccept}
        />
      }
    </React.Fragment>
  );
};

export default EntityAddress;
